import React, { Component } from "react"
import CircularProgress from "@material-ui/core/CircularProgress";
import Auth from "../../services/AuthService";

class LogoutRedirect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true
    }
  }

  componentDidMount() {
    this.setState({
      isLoaded: true
    });

    const { history } = this.props;

    Auth.logout();
    history.push("/");

    this.setState({
      isLoaded: false
    });

    return null;
  }


  render() {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center' }}>
        <div style={{ marginTop: '80px' }}>
          <CircularProgress disableShrink />
        </div>
      </div>
    );
  }

}

export default LogoutRedirect;